<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          class="box"
          ref="productForm"
          :model="product"
          label-width="70px"
        >
          <fieldset class="mgb15" v-if="showBaseInfoDF">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.productNo')">{{
                  product.productNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.unit')">{{
                  product.unit
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.category')">{{
                  product.categoryName
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.brand')">{{
                  product.brand
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.purchaseUrl')"
                  :prop="'purchaseUrl'"
                >
                  <a
                    v-if="
                      product.purchaseUrl != null &&
                      product.purchaseUrl.trim() != ''
                    "
                    :href="product.purchaseUrl"
                    target="_blank"
                    >链接</a
                  >
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="Permit.currentTenant().config.mesSchedule == true"
              >
                <el-form-item
                  :label="$t('product.mesCycle')"
                  :prop="'mesCycle'"
                >
                  {{ product.mesCycle }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset
            v-if="
              Permit.canActionsChargeEdition('globalCostPrice') &&
              mesCost.length != 0
            "
            class="mgb15"
          >
            <legend>{{ $t("phase.baseCost") }}</legend>
            <el-row>
              <el-col v-for="(c, index) of mesCost" :key="index" :span="8"
                >{{ c.factoryName }}:{{ c.cost | currency }}</el-col
              >
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>
              {{ $t("product.phase") }}
              <i
                v-if="
                  Permit.canActionsChargeEdition('mesProductDistributePhases')
                "
                class="el-icon-circle-plus green"
                @click="addPhase"
              />
              <el-select
                v-model="productNo"
                filterable
                clearable
                remote
                :placeholder="$t('prompt.searchProductNoToAddPhases')"
                size="mini"
                style="width: 270px"
                class="mgl5"
                :remote-method="querySearchProductNo"
                :loading="productsLoading"
                @change="handleSelectProductNo"
              >
                <el-option
                  v-for="p in products"
                  :key="p.productNo"
                  :label="p.productNo"
                  :value="p.productNo"
                />
              </el-select>
              <el-dropdown
                v-if="productPhases.length != 0"
                class="float-right"
                @command="downloadProductPhases"
              >
                <el-button type="default" size="mini">
                  {{ $t("action.download") }}
                  <i class="el-icon-caret-bottom el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="download1">
                    <div class="font10">{{ $t("action.download") }}</div>
                  </el-dropdown-item>
                  <el-dropdown-item command="download2">
                    <div class="font10">{{ $t("action.download") }}(简版)</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </legend>
            <vxe-table
              :data="productPhases"
              id="productPhasesTable"
              row-id="id"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              border
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column v-if="productPhases.length > 1" width="60px">
                <template v-slot="{ row, rowIndex }">
                  <i
                    v-if="rowIndex != 0"
                    class="el-icon-top mgr10"
                    @click="swapSequence(row, rowIndex, 'up')"
                  ></i>
                  <i
                    v-if="rowIndex + 1 != productPhases.length"
                    class="el-icon-bottom"
                    @click="swapSequence(row, rowIndex, 'down')"
                  ></i>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="phaseName"
                :title="$t('product.phase')"
                min-width="100"
              />
              <vxe-table-column
                field="phaseHour"
                :title="$t('phase.phaseHour')"
                min-width="60"
              />
              <vxe-table-column
                field="period"
                :title="$t('phase.period')"
                min-width="70"
              />
              <vxe-table-column
                field="inspect"
                :title="$t('phase.inspect')"
                width="50"
              >
                <template v-slot="{ row }">{{
                  $t("boolean." + row.inspect)
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="print"
                :title="$t('action.print')"
                width="50"
              >
                <template v-slot="{ row }">{{
                  $t("boolean." + row.print)
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActionsChargeEdition('globalCostPrice')"
                field="price"
                :title="$t('phase.price')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <div
                    v-for="(factoryPhase, index) of row.factoryPhases"
                    :key="index"
                    class="font10"
                  >
                    {{ factoryPhase.factoryName }}：{{
                      factoryPhase.phasePrice | currency
                    }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActionsChargeEdition('globalCostPrice')"
                field="factoryPhases"
                :title="$t('phase.subtotal')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <div
                    v-for="(factoryPhase, index) of row.factoryPhases"
                    :key="index"
                    class="font10"
                  >
                    {{ factoryPhase.factoryName }}：{{
                      (factoryPhase.phasePrice * row.phaseHour) | currency
                    }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="remark"
                :title="$t('text.remark')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number :content="row.remark" :number="16" />
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="
                  Permit.canActionsChargeEdition('mesProductDistributePhases')
                "
                field="action"
                :title="$t('text.action')"
                width="90"
              >
                <template v-slot="{ row }">
                  <el-button
                    type="text"
                    size="mini"
                    @click="editPhaseRow(row)"
                    >{{ $t("text.edit") }}</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    @click="deletePhaseRow(row)"
                    >{{ $t("text.delete") }}</el-button
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
    <!-- 编辑 工序-->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('product.phase')])"
      :visible.sync="editPhaseDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="editPhaseObjForm" :model="editPhaseObj" label-width="104px">
        <el-form-item
          :label="$t('phase.phaseHour')"
          :prop="'phaseHour'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phase.phaseHour')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editPhaseObj.phaseHour" />
        </el-form-item>
        <el-form-item
          :label="$t('phase.period')"
          :prop="'period'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phase.period')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editPhaseObj.period" />
        </el-form-item>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="editPhaseObj.remark"
            type="textarea"
          />
        </el-form-item>
        <el-form-item :prop="'print'">
          <el-checkbox size="small" v-model="editPhaseObj.print">{{
            $t("action.print")
          }}</el-checkbox>
        </el-form-item>
        <el-form-item :prop="'asyncPhasePlan'">
          <el-checkbox size="small" v-model="editPhaseObj.asyncPhasePlan">{{
            $t("prompt.asyncPhasePlan")
          }}</el-checkbox>
        </el-form-item>
        <el-form-item :prop="'asyncManufacture'">
          <el-checkbox size="small" v-model="editPhaseObj.asyncManufacture">{{
            $t("prompt.asyncManufacture")
          }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editPhaseDoing"
          size="small"
          @click="editPhaseSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPhaseDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增工序 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('menu.phases')])"
      :close-on-click-modal="false"
      :visible.sync="addPhaseDF"
      width="60%"
    >
      <el-form ref="addPhaseObjForm" :model="addPhaseObj">
        <vxe-table
          :data="phasesFilter"
          id="phasesFilterTable"
          row-id="phasesFilterid"
          ref="recordsTable"
          class="recordsTable"
          size="mini"
          resizable
          round
          highlight-hover-row
          auto-resize
          border
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column width="60px">
            <template v-slot="{ row, rowIndex }">
              <i
                v-if="rowIndex != 0"
                class="el-icon-top mgr10"
                @click="swapSequenceAdd(row, rowIndex, 'up')"
              ></i>
              <i
                v-if="rowIndex + 1 != phasesFilter.length"
                class="el-icon-bottom"
                @click="swapSequenceAdd(row, rowIndex, 'down')"
              ></i>
            </template>
          </vxe-table-column>
          <vxe-table-column field="phaseName" :title="$t('product.phase')" />
          <vxe-table-column field="phaseHour" :title="$t('phase.phaseHour')">
            <template v-slot="{ row }">
              <el-input
                size="small"
                v-model.trim="row.phaseHour"
                :placeholder="$t('rules.mustFill', [''])"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="period" :title="$t('phase.period')">
            <template v-slot="{ row }">
              <el-input
                size="small"
                v-model.trim="row.period"
                :placeholder="$t('rules.mustFill', [''])"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="inspect"
            :title="$t('phase.inspect')"
            width="50"
          >
            <template v-slot="{ row }">
              <el-checkbox size="small" v-model="row.inspect" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="print"
            :title="$t('action.print')"
            width="50"
          >
            <template v-slot="{ row }">
              <el-checkbox size="small" v-model="row.print" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="asyncUnFinishWO"
            :title="$t('phase.asyncUnFinishWO')"
            width="80"
          >
            <template v-slot="{ row }">
              <el-checkbox size="small" v-model="row.asyncUnFinishWO" />
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" :title="$t('text.remark')">
            <template v-slot="{ row }">
              <el-input size="small" v-model.trim="row.remark" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button
                type="text"
                size="mini"
                @click="removePhase(rowIndex)"
                >{{ $t("text.remove") }}</el-button
              >
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addPhaseDoing"
          size="small"
          @click="addPhaseSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addPhaseDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Product from "@/api/product.js";
import Phase from "@/api/phase.js";

export default {
  props: {
    uuid: String,
    showBaseInfoDF: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [page],
  components: {},
  data() {
    return {
      product: { uuid: null },
      productPhases: [],
      mesCost: [],
      // 编辑
      editPhaseDF: false,
      editPhaseObj: {
        phaseId: null,
        phaseName: null,
        sequence: null,
        phaseHour: null,
        period: null,
        asyncPhasePlan: true,
        asyncManufacture: true,
        productId: null,
        print: null,
        remark: null,
      },
      editPhaseDoing: false,
      // 工序 新增
      phasesFilter: [],
      addPhaseDF: false,
      addPhaseObj: {},
      addPhaseDoing: false,
      //
      productNo: null,
      products: [],
      productsLoading: false,
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    Product.findByUuid({ uuid: self.uuid }).then(function (res) {
      if (res.data.code === 200) {
        self.product = res.data.entity;
        self.getProductPhases();
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    downloadProductPhases(cmd) {
      const self = this;
      if (cmd == "download1") {
        Product.exportExcelPhasesById(self.product.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        });
      } else {
        Product.exportExcelForEditPhases(self.product.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        });
      }
    },

    swapSequence(row, rowIndex, type) {
      const self = this;
      const obj = {
        swapId: row.id,
        swapId2:
          type == "up"
            ? self.productPhases[rowIndex - 1].id
            : self.productPhases[rowIndex + 1].id,
      };
      Product.swapSequence(obj).then(function (res) {
        if (res.status == 200) {
          self.getProductPhases();
        } else {
          self.sysError();
        }
      });
    },

    // 加载配工序
    querySearchProductNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.productsLoading = true;
      Product.vagueFindByProductNoAll({ productNo: queryString }).then(
        function (res) {
          self.products = res.data;
          self.productsLoading = false;
        }
      );
    },
    handleSelectProductNo(idx) {
      const self = this;
      const item = self.products.find((p) => p.productNo === self.productNo);
      if (item != null) {
        Product.productPhases(item.id).then(function (res) {
          if (res.status === 200) {
            const selectedProductNoPhases = res.data;
            if (selectedProductNoPhases.length === 0) {
              self.$message({
                message: self.$t("prompt.productNoNoPhaseInfo"),
                type: "warning",
              });
              return;
            }
            //

            const selectedProductNoPhasesFilter =
              selectedProductNoPhases.filter(
                (selectedProductNoPhase) =>
                  self.productPhases.find(
                    (productPhase) =>
                      productPhase.phaseId === selectedProductNoPhase.phaseId
                  ) == null
              );
            if (selectedProductNoPhasesFilter.length === 0) {
              self.$message({
                message: self.$t("prompt.productNoNoPhaseHasExist"),
                type: "warning",
              });
              return;
            }

            const newAddProductPhases = selectedProductNoPhasesFilter.map(
              (p) => {
                return {
                  productId: self.product.id,
                  phaseId: p.phaseId,
                  phaseName: p.phaseName,
                  phaseHour: p.phaseHour,
                  period: p.period,
                  inspect: p.inspect,
                  print: p.print,
                };
              }
            );

            Product.cteatePhases(newAddProductPhases).then(function (res) {
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.addSuccess"),
                  type: "success",
                });
                self.productNo = null;
                self.getProductPhases();
              } else {
                self.sysError();
              }
            });
          } else {
            self.sysError();
          }
        });
      }
    },

    // 新增工序
    swapSequenceAdd(row, rowIndex, type) {
      const self = this;
      const currentRowSequence = row.sequence;
      if (type == "up") {
        const currentRowUpSequence = self.phasesFilter[rowIndex - 1].sequence;
        self.phasesFilter[rowIndex].sequence = currentRowUpSequence;
        self.phasesFilter[rowIndex - 1].sequence = currentRowSequence;
      }
      if (type == "down") {
        const currentRowDownSequence = self.phasesFilter[rowIndex + 1].sequence;
        self.phasesFilter[rowIndex].sequence = currentRowDownSequence;
        self.phasesFilter[rowIndex + 1].sequence = currentRowSequence;
      }
      self.phasesFilter.sort(function (a, b) {
        return a.sequence - b.sequence;
      });
    },
    addPhase() {
      const self = this;
      self.phasesFilter = [];
      Phase.findByTenantId().then(function (res) {
        if (res.status === 200) {
          const phases = res.data;
          const phasesFilter = phases.filter(
            (p) =>
              self.productPhases.find(
                (productPhase) => productPhase.phaseId === p.id
              ) == null
          );
          self.phasesFilter = phasesFilter.map((p, idx) => {
            return {
              productId: self.product.id,
              phaseId: p.id,
              phaseName: p.name,
              sequence: idx + 1,
              phaseHour: null,
              period: null,
              inspect: false,
              print: false,
              asyncUnFinishWO: false,
            };
          });
          self.addPhaseDoing = false;
          self.addPhaseDF = true;
        } else {
          self.sysError();
        }
      });
    },
    removePhase(rowIndex) {
      this.phasesFilter.splice(rowIndex, 1);
    },
    addPhaseSubmit() {
      const self = this;
      self.$refs.addPhaseObjForm.validate((valid) => {
        if (valid) {
          const phasesFilter = self.phasesFilter.filter(
            (c) => c.phaseHour != null && c.period != null
          );
          if (phasesFilter.length === 0) {
            this.$message({
              message: self.$t("prompt.atLeastOneValidDataFillIn"),
              type: "warning",
            });
            return;
          }
          for (const phase of phasesFilter) {
            if (!Util.regexQuantity(phase.phaseHour)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("phase.phaseHour")]),
                type: "warning",
              });
              return;
            }
            if (!Util.regexQuantity(phase.period)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("phase.period")]),
                type: "warning",
              });
              return;
            }
          }
          self.addPhaseDoing = true;
          Product.cteatePhases(phasesFilter).then(function (res) {
            self.addPhaseDoing = false;
            self.addPhaseDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getProductPhases();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 删除工序
    deletePhaseRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Product.deletePhase(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getProductPhases();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑工序
    editPhaseRow(row) {
      const self = this;
      self.row = row;
      self.editPhaseObj.productId = self.product.id;
      self.editPhaseObj.phaseId = row.phaseId;
      self.editPhaseObj.phaseName = row.phaseName;
      self.editPhaseObj.sequence = row.sequence;

      self.editPhaseObj.phaseHour = row.phaseHour;
      self.editPhaseObj.period = row.period;
      self.editPhaseObj.print = row.print;
      self.editPhaseObj.remark = row.remark;
      self.editPhaseObj.asyncPhasePlan = true;
      self.editPhaseObj.asyncManufacture = true;
      self.editPhaseDoing = false;
      self.editPhaseDF = true;
    },
    editPhaseSubmit() {
      const self = this;
      self.$refs.editPhaseObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editPhaseObj.phaseHour)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("phase.phaseHour")]),
              type: "warning",
            });
            return;
          }
          if (!Util.regexQuantity(self.editPhaseObj.period)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("phase.period")]),
              type: "warning",
            });
            return;
          }
          self.editPhaseDoing = true;
          Product.updatePhase(self.row.id, self.editPhaseObj).then(function (
            res
          ) {
            self.editPhaseDoing = false;
            self.editPhaseDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getProductPhases();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 工序
    getProductPhases() {
      const self = this;
      Product.productPhases(self.product.id).then(function (res) {
        if (res.status === 200) {
          self.productPhases = res.data;
          self.computeMesCost(self.productPhases);
        } else {
          self.sysError();
        }
      });
    },
    computeMesCost() {
      const self = this;
      self.mesCost = [];
      const datas = [];
      if (self.productPhases.length !== 0) {
        for (const p of self.productPhases) {
          if (p.factoryPhases.length !== 0) {
            for (const fp of p.factoryPhases) {
              const obj = {
                phaseId: fp.phaseId,
                phaseName: fp.phaseName,
                factoryName: fp.factoryName,
                phasePrice: fp.phasePrice,
                phaseHour: p.phaseHour,
                subtotal: fp.phasePrice * p.phaseHour,
              };
              datas.push(obj);
            }
          }
        }
        const factoryNamesArr = datas.map((s) => s.factoryName);
        const filterFactoryNamesArr = [...new Set(factoryNamesArr)];
        for (const fname of filterFactoryNamesArr) {
          const obj = {
            factoryName: fname,
            factory: datas.filter((d) => d.factoryName === fname),
            cost: 0,
          };
          for (const f of obj.factory) {
            obj.cost = f.subtotal + obj.cost;
          }
          self.mesCost.push(obj);
        }
      }
    },
  },
};
</script>